/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

// Change the margin to 8 px once we upgrade to the latest `@atlaskit/button` mentioned here:
// https://hello.atlassian.net/wiki/spaces/DPT/blog/2020/06/02/743608848/Buttons+with+icons+spacing+adjustments
export const CopyButtonWrapper = styled.div`
  margin-left: 6px;
  min-width: max-content;
`;

export const MenuContainer = styled.div`
  display: inline-block;

  > * {
    display: inline-block;
    margin-right: ${gridSize()}px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const Tags = styled.div`
  margin-right: ${gridSize()}px;
`;
